import React, { useState, useEffect } from 'react';
import {
  Card,
  Button,
  Modal,
  Alert,
  Form,
  Table,
  Dropdown
} from 'react-bootstrap';
import axios from 'axios';
import PageTitle from 'components/common/PageTitle';
import Loading from 'components/common/Loading';

const DBQuery = props => {
  const [query, setQuery] = useState('');
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tables, setTables] = useState([]);

  useEffect(getTables, []);

  async function getTables() {
    try {
      const res = await axios.post('/pmladmin/db/tables');
      setTables(res.data);
    } catch {
      setError('Failed to fetch tables');
    }
  }

  async function runQuery() {
    setError(null);
    setColumns([]);
    setRows([]);
    setLoading(true);
    try {
      const res = await axios.post('/pmladmin/db/query', { query });
      setColumns(res.data.columns);
      setRows(res.data.rows);
    } catch (e) {
      console.log(e);
      setError(e.response.data);
    }
    setLoading(false);
  }

  function downloadCSV() {
    if (columns.length === 0) {
      return;
    }

    let csvContent = '';
    csvContent += columns.join(',') + '\n';
    csvContent += rows.map(row => row.map(col => col).join(',')).join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `pml-${new Date().toISOString()}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <PageTitle app="Database" page="Query" />
        <div style={{ display: 'flex', gap: 8 }}>
          <Button
            variant="danger"
            onClick={downloadCSV}
            style={{ height: 'fit-content' }}
            disabled={columns.length === 0}
          >
            Download
          </Button>
          <Button
            variant="danger"
            onClick={runQuery}
            style={{ height: 'fit-content' }}
          >
            Run Query
          </Button>
        </div>
      </div>
      <div style={{ width: '100%', display: 'grid' }}>
        {error && <Alert variant="danger">{error}</Alert>}
        {rows.length > 0 && (
          <Alert variant="success">Returned {rows.length} rows</Alert>
        )}
        <Form.Group style={{ marginBottom: 16 }}>
          <Form.Label>Tables</Form.Label>
          <Form.Select
            onChange={e => {
              setQuery(e.target.value);
            }}
          >
            {tables.map((table, i) => (
              <option key={i} value={`SELECT TOP 1000 * FROM ${table}`}>
                {table}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <Form
          as="textarea"
          rows={3}
          style={{ fontFamily: 'monospace' }}
          value={query}
          onChange={e => setQuery(e.target.value)}
        />
      </div>
      {loading && <Loading />}
      <div
        style={{
          display: 'flex',
          marginTop: 16,
          maxHeight: 900,
          overflow: 'auto'
        }}
      >
        {columns.length > 0 && (
          <Table
            className="w-100 overflow-visible"
            striped
            bordered
            hover
            responsive
            style={{ width: '100%' }}
          >
            <thead style={{ position: 'sticky', top: 0, background: '#fff' }}>
              <tr>
                {columns.map((col, i) => (
                  <th key={i}>{col}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {columns.map((col, colIndex) => (
                    <td key={colIndex}>
                      {typeof row[colIndex] === 'boolean'
                        ? String(row[colIndex])
                        : row[colIndex]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>
    </>
  );
};

export default DBQuery;
